<template>
<div id="social-btn" class="mt-2">

  <v-speed-dial
    v-model="fab"
    bottom
    right
    :direction="direction"
    :transition="transition"
    class="d-inline"
  >
    <template v-slot:activator>
      <v-btn v-model="fab" color="blue darken-2" dark fab x-small>
        <v-icon v-if="fab">mdi-close</v-icon>
        <v-icon v-else>mdi-share-variant</v-icon>
      </v-btn>
    </template>
    <div v-for="item in social" :key="item.link">

      <v-tooltip bottom open-delay="1000">
        <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          small
          :color="item.color"
          :href="item.link"
          target="_blank"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
        </template>
        <span>{{ item.tooltipText }}</span>

      </v-tooltip>
    </div>
  </v-speed-dial>
</div>
</template>

<script>
export default {
  props: {
    social: {
      type: Array,
      required: true
    },
    direction: {
      type: String,
      default: "left"
    },
    transition: {
      type: String,
      default: "slide-x-reverse-transition"
    }
  },
  data() {
    return {
      fab: false
    }
  }
}
</script>